import React from 'react'
import { Row, Col, Form, InputGroup } from 'react-bootstrap';

const PaymentInfo = ({action, paymentInfo, isEPayment, onChange, disabled}) => {
    const bankAccts = paymentInfo.bankAccts.map(item =>
        <option key={item} value={item}>{item}</option>
    );

    return (
        <React.Fragment>
            <Row>
                <Col sm={12} className="font-weight-bold">
                    Payment Information
                </Col>
            </Row>
            <Row className="my-3">
                <Col sm={12}>
                    <Row>                    
                        <Col sm={6}>
                            <Form.Group controlId="accountNo">
                                <Form.Label className="text-grey font-weight-bold medium required">Bank Account Number</Form.Label>
                                <Form.Control 
                                    as="select" 
                                    name="accountNo" 
                                    onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                    value={paymentInfo ? paymentInfo.accountNo : ''} 
                                    disabled={disabled}
                                    required>
                                    <option value="" hidden>Select</option>
                                    {bankAccts}
                                </Form.Control>
                            </Form.Group>
                        </Col>      
                        <Col sm={6}>
                            <Form.Group controlId="merchantCustomerId">
                                <Form.Label className="text-grey font-weight-bold medium">Merchant's Customer ID</Form.Label>
                                <Form.Control
                                    name="merchantCustomerId" type="text"
                                    placeholder="Enter merchant's customer ID"
                                    maxLength={25}
                                    disabled={disabled || action !== 'create'}
                                    onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                    value={paymentInfo ? paymentInfo.merchantCustomerId : ''}
                                />
                            </Form.Group>
                        </Col>           
                    </Row>
                    <Row>                            
                        <Col sm={6}>
                            <Form.Group controlId="paymentChannel">
                                <Form.Label className="text-grey font-weight-bold medium">Customer Payment Channel</Form.Label>
                                <Form.Control
                                    name="regisChanpaymentChannelnel" type="text"
                                    placeholder="Enter customer payment channel"
                                    disabled={true}
                                    onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                    value={paymentInfo ? paymentInfo.paymentChannel : ''}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="regisChannel">
                                <Form.Label className="text-grey font-weight-bold medium">Customer Registration Channel</Form.Label>
                                <Form.Control
                                    name="regisChannel" type="text"
                                    placeholder="Enter customer registration channel"
                                    disabled={true}
                                    onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                    value={paymentInfo ? paymentInfo.regisChannel : ''}
                                />
                            </Form.Group>
                        </Col>                    
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="prefix">
                                <Form.Label className="text-grey font-weight-bold medium required">Setup User ID</Form.Label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <Form.Control 
                                            as="select" 
                                            name="prefix" 
                                            onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                            value={paymentInfo ? paymentInfo.prefix : ''} 
                                            disabled={disabled || !isEPayment || action !== 'create'}
                                            >
                                            <option value="">Select</option>
                                            <option value="RD">RD</option>
                                            <option value="SSO">SSO</option>
                                        </Form.Control>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        name="userId" type="text"
                                        placeholder="Enter user ID"
                                        disabled={disabled || !isEPayment || action !== 'create'}
                                        onChange={(e) => onChange('paymentInfo', e.target.name, e.target.value)}
                                        value={paymentInfo ? paymentInfo.userId : ''}
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="prefix">
                                <Form.Label className="text-grey font-weight-bold medium">User ID for E-Payment User</Form.Label>
                                <Form.Row>
                                    <Col className="pt-2 text-grey">
                                        {paymentInfo.userId === "" ? "-" : paymentInfo.prefix + paymentInfo.userId}
                                    </Col>
                                </Form.Row>
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PaymentInfo
